import React, { useContext } from 'react'
import { get } from 'lodash'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Dropdown, Icon, Button } from 'semantic-ui-react'
import { AppContext } from '../context/app'
import src from '../assets/images/imaware-logo-bw.svg'
import { ROUTES } from '../constants'
import useNavigation from '../hooks/useNavigation'
import useRoute from '../hooks/useRoute'

const Wrapper = styled.div`
  background: #f1f3f5;
  width: 100%;
  max-width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;

  @media print {
    display: none;
  }
`

const Logo = styled.img.attrs({
  src
})`
  max-width: 114px;
  margin: 2rem;
  pointer-events: none;
`

const Title = styled.p`
  position: relative;
  bottom: 1.5rem;
`

const Break = styled.hr`
  width: 100%;
  border: none;
  height: 2px;
  background: #dad9d9;
`

const Items = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NavItem = styled(Link)`
  color: #000;
  text-transform: uppercase;
  margin: 25px 0;
  display: flex;
  align-items: center;
  ${({ selected }) => selected && `color: #4183c4;`}}
  text-align: center;
`

const ProfileIcon = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0 0.3rem 0;
`

const Actions = styled.div`
  padding: 25px;
`

const Notifications = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #007acb;
  min-width: 25px;
  height: 25px;
  border-radius: 0.5rem;
  margin-left: 0.5rem;
`

const DropdownWrapper = styled(Dropdown)`
  &.ui.dropdown {
    display: flex;
    flex-direction: column;
    max-width: 50%;
    .dropdown.icon {
      margin: 0;
    }
  }
  i.icon {
    margin: 0;
  }
`

const trigger = (name = '') => (
  <>
    <ProfileIcon>
      <Icon name="user circle" size="large" />
    </ProfileIcon>
    <>{name}</>
  </>
)
const Nav = () => {
  const {
    endSession,
    user,
    requisitionNotifications,
    resultNotifications,
    covidResultNotifications
  } = useContext(AppContext)
  const url = useRoute()
  const navigate = useNavigation()

  const notificationReducer = route => {
    let count
    switch (route) {
      case get(ROUTES, '[0][0].route'):
        count = requisitionNotifications
        break
      case get(ROUTES, '[0][1].route'):
        count = resultNotifications
        break
      case get(ROUTES, '[0][2].route'):
        count = covidResultNotifications
        break
      default:
    }
    if (count) return <Notifications>{count}</Notifications>
    return <></>
  }

  return (
    <Wrapper>
      <Logo />
      <Title>Doctor Portal</Title>
      <Break />
      <Items>
        {ROUTES[0].map(({ name, route, hasNotifications = false }) => (
          <NavItem
            selected={url && url.substring(1) === route}
            key={route}
            to={`/${route}`}
          >
            {name}
            {hasNotifications && notificationReducer(route)}
          </NavItem>
        ))}
      </Items>
      <Break />
      <Items>
        {ROUTES[1].map(({ name, route, hasNotifications = false }) => (
          <NavItem
            selected={url && url.substring(1) === route}
            key={route}
            to={`/${route}`}
          >
            {name}
          </NavItem>
        ))}
      </Items>
      <Break />
      <Actions>
        <Button
          primary
          onClick={() => {
            navigate('/create-requisition')
          }}
        >
          Create New Requisition
        </Button>
      </Actions>
      <DropdownWrapper trigger={trigger(get(user, 'name', ''))}>
        <Dropdown.Menu>
          <Dropdown.Item onClick={endSession}>Logout</Dropdown.Item>
        </Dropdown.Menu>
      </DropdownWrapper>
    </Wrapper>
  )
}

export default Nav
